/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Controller, useWatch } from "react-hook-form";
import {
    Autocomplete,
    TextField,
    Checkbox,
    List,
    ListItem,
    Divider,
    Tooltip,
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';




const custom = ({
    handleSelectAction,
    field,
    inputValue,
    isAllFilteredSelected,
    isAllSelected,
    getSelectActionLabel,
    ...props
}) => (
    <List {...props} style={{ background: "white", color: "black" }}>
        <ListItem
            onMouseDown={(event) => event.preventDefault()} // Prevent focus loss
            onClick={() => handleSelectAction(field)} // Pass field to update form values
            sx={{
                display: "flex",
                height: "2rem",
                alignItems: "center",
                paddingLeft: "1.9em",
                fontSize: "13px",
            }}
        >
            <Checkbox
                checked={inputValue ? isAllFilteredSelected : isAllSelected}
                style={{ marginRight: 8 }}
                size="small"
            />
            <span style={{ fontSize: "13px" }}> {getSelectActionLabel()} </span>  {/* Make sure this is accessible */}
        </ListItem>
        <Divider />
        {props.children}
    </List>
);



const RHFAutocomplete = ({ formData, control, getDataFunc, isDisabled }) => {
    const [loading, setLoading] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    // Strip Target_ prefix and _<number> suffix from DisplayExpr and ValueExpr for accessing API-returned option data
    // API returns fields like "Item" and "ItemId", but formData may have "Target_Item", "ItemId_1", etc.
    const optionDisplayExpr = formData?.DisplayExpr?.replace(/^Target_/, '')?.replace(/_\d+$/, '') || formData?.DisplayExpr;
    const optionValueExpr = formData?.ValueExpr?.replace(/^Target_/, '')?.replace(/_\d+$/, '') || formData?.ValueExpr;

    const getOptionValue = (opt) => {
        if (!opt) return null;
        if (typeof opt !== 'object') return opt;
        return (
            opt[optionValueExpr] ??
            opt[formData?.ValueExpr] ??
            opt.ItemId ??
            opt.Rule_FreeItemId ??
            opt.Id ??
            opt.id ??
            null
        );
    };

    const getOptionLabel = (opt) => {
        if (!opt) return '';
        if (typeof opt !== 'object') return String(opt);
        return (
            opt[optionDisplayExpr] ??
            opt[formData?.DisplayExpr] ??
            opt.Item ??
            opt.Rule_FreeItem ??
            opt.Name ??
            opt.label ??
            ''
        );
    };

    const isSameOption = (optA, optB) => {
        if (!optA || !optB) return false;
        const valA = getOptionValue(optA);
        const valB = getOptionValue(optB);
        if (valA !== null && valA !== undefined && valB !== null && valB !== undefined) {
            if (String(valA).toLowerCase().trim() === String(valB).toLowerCase().trim()) return true;
        }
        const labelA = getOptionLabel(optA);
        const labelB = getOptionLabel(optB);
        if (labelA && labelB && String(labelA).toLowerCase().trim() === String(labelB).toLowerCase().trim()) {
            return true;
        }
        return false;
    };

    const value = useWatch({ control, name: formData.ValueExpr });

    useEffect(() => {
        if (Array.isArray(value) && value.length > 0) {
            // Merge any missing items from value into options
            // This ensures edit mode values are always in the options array
            setOptions((prevOptions) => {
                const missingOptions = value.filter(
                    (valItem) => !prevOptions.some((optItem) => isSameOption(optItem, valItem))
                );

                // Always add missing options - this is critical for edit mode
                // where values are set before any API fetch populates options
                if (missingOptions.length > 0) {
                    return [...prevOptions, ...missingOptions];
                }

                return prevOptions;
            });

            // Ensure selectedOptions is in sync with form value
            setSelectedOptions(value);
        } else {
            setSelectedOptions([]);
        }
    }, [value, formData.ValueExpr]);

    // Additional effect to handle initial edit mode - ensure options contain the values
    // This runs once when component mounts with a pre-set value
    useEffect(() => {
        if (Array.isArray(value) && value.length > 0 && options.length === 0) {
            // Options are empty but we have values - initialize options with value items
            setOptions(value);
        }
    }, []);

    const filteredOptions = useMemo(() => {
        let opts = options;
        // Deduplicate options list itself first
        const uniqueOpts = [];
        const seenOptKeys = new Set();
        (opts || []).forEach(opt => {
            const val = getOptionValue(opt);
            const label = getOptionLabel(opt);
            const key = String(val ?? label ?? '').toLowerCase().trim();
            const labelKey = label ? String(label).toLowerCase().trim() : '';
            if (key && !seenOptKeys.has(key) && (!labelKey || !seenOptKeys.has(labelKey))) {
                seenOptKeys.add(key);
                if (labelKey) seenOptKeys.add(labelKey);
                uniqueOpts.push(opt);
            }
        });
        opts = uniqueOpts;

        if (formData?.excludeValues && Array.isArray(formData.excludeValues) && formData.excludeValues.length > 0) {
            const excludeSet = new Set(formData.excludeValues.map(v => String(v).toLowerCase().trim()));
            opts = opts.filter(option => {
                const optVal = getOptionValue(option);
                const optLabel = getOptionLabel(option);
                if (optVal !== null && optVal !== undefined && excludeSet.has(String(optVal).toLowerCase().trim())) {
                    return false;
                }
                if (optLabel && excludeSet.has(String(optLabel).toLowerCase().trim())) {
                    return false;
                }
                return true;
            });
        }
        if (!inputValue) return opts;

        if (formData.TableName === "ClaimPreview") {

            return opts?.filter((option) =>
                option?.ContractName
                    ?.toLowerCase()
                    ?.includes(inputValue.toLowerCase())
            );
        }
        return opts?.filter((option) =>
            getOptionLabel(option)
                ?.toLowerCase()
                ?.includes(inputValue.toLowerCase())
        );
    }, [options, inputValue, formData.DisplayExpr, optionDisplayExpr, formData?.excludeValues]);



    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    useEffect(() => {
        // If the field value changes programmatically (like through reset), update selectedOptions
        if (control._formValues) {
            const currentVal = control._formValues[formData?.ValueExpr];
            if (Array.isArray(currentVal)) {
                setSelectedOptions(currentVal);
            } else if (!currentVal) {
                setSelectedOptions([]);
            }
        }
    }, [formData?.ValueExpr, options, control._formValues]);


    const isAllSelected = selectedOptions.length === options.length && options.length !== 0;
    const isAllFilteredSelected = selectedOptions?.length > 0 && filteredOptions.length > 0 && filteredOptions.every((option) =>
        selectedOptions.some(
            (selected) => {
                const sVal = getOptionValue(selected);
                const oVal = getOptionValue(option);
                return sVal !== null && oVal !== null && String(sVal) === String(oVal);
            }
        )
    );

    const handleSelectAction = (field) => {
        if (inputValue) {
            if (isAllFilteredSelected) {
                // Unselect filtered options
                const updatedOptions = selectedOptions.filter(
                    (selected) => {
                        const sVal = getOptionValue(selected);
                        return !filteredOptions.some(
                            (filtered) => {
                                const fVal = getOptionValue(filtered);
                                return fVal !== null && String(fVal) === String(sVal);
                            }
                        );
                    }
                );
                setSelectedOptions(updatedOptions);
                field.onChange(updatedOptions); //  Use full objects
            } else {
                // Select filtered options
                const newSelectedOptions = [
                    ...selectedOptions,
                    ...filteredOptions.filter(
                        (filtered) => {
                            const fVal = getOptionValue(filtered);
                            return !selectedOptions.some(
                                (selected) => {
                                    const sVal = getOptionValue(selected);
                                    return sVal !== null && String(sVal) === String(fVal);
                                }
                            );
                        }
                    ),
                ];
                setSelectedOptions(newSelectedOptions);
                field.onChange(newSelectedOptions); //  Use full objects
            }
        } else {
            if (isAllSelected) {
                // Unselect all
                setSelectedOptions([]);
                field.onChange([]); //  Use full objects (empty)
            } else {
                // Select all
                setSelectedOptions(options);
                field.onChange(options); //  Use full objects
            }
        }
    };



    const getSelectActionLabel = () => {
        if (inputValue) {
            return isAllFilteredSelected
                ? "Unselect Filtered Options"
                : "Select Filtered Options";
        } else {
            return isAllSelected ? "Unselect All" : "Select All";
        }
    };

    const fetchData = async (query) => {

        setLoading(true);
        let response = null;

        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            response = await getDataFunc({
                "SearchText": query
            });

        }
        else if (formData?.TableName === 'ClaimPreview') {

            response = await getDataFunc({
                "SearchText": query
            });

        }
        else {
            // Strip Target_ prefix and _<number> suffix from DisplayExpr for ControlId (API expects base field name)
            const displayExprForApi = formData?.DisplayExpr?.replace(/^Target_/, '')?.replace(/_\d+$/, '');
            response = await getDataFunc({
                "ControlId": `${formData?.TableName}-${displayExprForApi}`,
                "Values": query,
            });
        }

        let newOptions = null;
        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            newOptions = Array.isArray(response?.data?.DefaultValues) ? response?.data?.DefaultValues : [];
        }
        else if (formData?.TableName === 'ClaimPreview') {

            newOptions = Array.isArray(response?.DefaultValues) ? response?.DefaultValues : [];
        }
        else {
            newOptions = Array.isArray(response?.data) ? response?.data : [];
        }


        setOptions((prevOptions) => {
            const newUniqueOptions = newOptions.filter(
                (newOption) => !prevOptions.some((existingOption) => isSameOption(existingOption, newOption))
            );
            return [...prevOptions, ...newUniqueOptions]; // Add the new unique options
        });
        setLoading(false);

    };



    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => ( // NOSONAR

                <Autocomplete
                    {...field}
                    disabled={isDisabled}
                    multiple
                    options={filteredOptions}
                    getOptionDisabled={(option) => {
                        if (!formData?.excludeValues || !Array.isArray(formData.excludeValues)) return false;
                        const excludeSet = new Set(formData.excludeValues.map(v => String(v).toLowerCase().trim()));
                        const optVal = getOptionValue(option);
                        const optLabel = getOptionLabel(option);
                        if (optVal !== null && optVal !== undefined && excludeSet.has(String(optVal).toLowerCase().trim())) return true;
                        if (optLabel && excludeSet.has(String(optLabel).toLowerCase().trim())) return true;
                        return false;
                    }}
                    loading={loading}
                    noOptionsText={
                        <span style={{ fontSize: "13px" }}>
                            {inputValue.length < 3 ? "Please type at least 3 characters to search..." : "No results found"}
                        </span>
                    }
                    value={field.value ?? []}
                    inputValue={inputValue}
                    // onInputChange={handleInputChange}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                            setInputValue(newInputValue);

                            // If there's a previous debounce timeout, clear it
                            if (debounceTimeout) {
                                clearTimeout(debounceTimeout);
                            }

                            // Set a new timeout for the fetch call
                            const newTimeout = setTimeout(() => {
                                if (newInputValue.length >= 3) {
                                    fetchData(newInputValue);
                                }
                            }, 500); // Set delay to 500ms (can be adjusted)

                            setDebounceTimeout(newTimeout);
                        }
                    }}
                    getOptionLabel={(option) => getOptionLabel(option)}
                    isOptionEqualToValue={(option, valuee) => isSameOption(option, valuee)}
                    onChange={(event, valuee, reason) => {
                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                            let incomingArr = [];
                            if (Array.isArray(valuee)) {
                                incomingArr = valuee;
                            } else if (valuee) {
                                incomingArr = [valuee];
                            }
                            const uniqueValues = [];
                            const seenKeys = new Set();
                            incomingArr.forEach((item) => {
                                const val = getOptionValue(item);
                                const label = getOptionLabel(item);
                                const key = String(val ?? label ?? '').toLowerCase().trim();
                                const labelKey = label ? String(label).toLowerCase().trim() : '';
                                if (key && !seenKeys.has(key) && (!labelKey || !seenKeys.has(labelKey))) {
                                    seenKeys.add(key);
                                    if (labelKey) seenKeys.add(labelKey);
                                    uniqueValues.push(item);
                                }
                            });
                            const fallbackVal = uniqueValues.length > 0 ? uniqueValues[0] : null;
                            const finalValue = Array.isArray(valuee) ? uniqueValues : fallbackVal;
                            setSelectedOptions(finalValue ?? []);
                            field.onChange(finalValue);
                        }
                    }}
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ fontSize: "13px" }} key={getOptionValue(option) || getOptionLabel(option)}>
                            <Checkbox style={{ marginRight: 8 }} checked={selected} size='small' />
                            {getOptionLabel(option)}
                        </li>
                    )}
                    renderTags={(selected, getTagProps) => {
                        const label =
                            selected.length > 0 ? `${selected.length} items selected` : "";
                        return (
                            <span style={{ fontSize: "13px", paddingLeft: "0.5em" }}>
                                {label}
                            </span>
                        );
                    }}

                    slots={{
                        paper: custom,
                    }}
                    slotProps={{
                        paper: {
                            handleSelectAction,
                            field,
                            inputValue,
                            isAllFilteredSelected,
                            isAllSelected,
                            getSelectActionLabel,
                        },
                    }}

                    PaperComponent={custom}


                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: field?.value != null && field.value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '13px',
                                            fontWeight: '300',
                                        }}
                                    >

                                        {Array.isArray(field?.value) && field.value.length > 0
                                            && field.value.map(item => getOptionLabel(item)).join(", ")
                                        }


                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: 'white', // Match the arrow color with the tooltip background
                                    },
                                    display: field.value == null || field.value?.length === 0 ? 'none' : ''
                                },
                            }}
                        >
                            <TextField
                                {...params}
                                label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                    <span style={{ color: isDisabled ? 'inherit' : "red", marginLeft: "2px" }}>*</span>
                                )}</>}
                                variant="outlined"
                                size="small"
                                // error={!!error}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}

                                helperText={
                                    error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                                }
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                    },
                                    "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: formData?.emptyFieldBgColor && (field.value == null || field.value?.length === 0) ? formData.emptyFieldBgColor : undefined,
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                />


            )}
        />
    );
};

export default RHFAutocomplete;
